import axios from 'axios'
import router from '../router/index'
import { TokenStore } from '../services/TokenStore'

const $axios = axios.create();

$axios.interceptors.request.use(
  async (config) => {
    const token = TokenStore.getToken();

    if (token) {
      config.headers = {
        ...config.headers,
        authorization: `Bearer ${token}`,
      };
    }

    return config;
  },
  (error) => Promise.reject(error)
);

$axios.interceptors.response.use(response => {
  return response;
}, error => {
  if(error.response.status === 401){
    TokenStore.setToken('');
    router.push('/login');
  }
  if (error.response.status === 403 && error.response.data.error.reason === 'USER_BANNED') {
      router.push('/banned');
  }
    return Promise.reject(error);
});

export  { $axios , axios };
